import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import { WindowMU } from "app/types/WindowMU"
import globalMU from "globalMU"

declare var window:WindowMU


export type DefinirCentroCustoItemInput = {
    idCentroCusto: number
    identificadorItem: number
}

export async function definirCentroCustoItem(input: DefinirCentroCustoItemInput) {
    globalMU.blockUI()
    try {
        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirCentroCustoItemOrcamento(
            store.getState().orcamento.IdentificadorOrcamento,
            input.identificadorItem,
            input.idCentroCusto
        )

        const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == input.identificadorItem)
    
        const orcamentoLegado = window.orcamentoController.model
        //const itensLegado = orcamentoLegado.get('ItensOrcamento')
        //const itemLegado = itensLegado.models.find(item => item.get('Identificador') == input.identificadorItem)

        //itemLegado.atualizar(itemAtualizado,true)
        orcamentoLegado.atualizar(orcamentoAtualizado)
    } finally {
        globalMU.unblockUI()
    }
}